import { Theme } from '@mui/material'

export function isDarkTheme(theme: Theme) {
    return theme.palette.mode === 'dark'
}

export const getNavTextColor = (theme: Theme) =>
    isDarkTheme(theme) ? '#FBFBFB' : theme.palette.grey[800]
